// extracted by mini-css-extract-plugin
module.exports = {"tourCurrentPassword":"Password_tourCurrentPassword__1O7N4","tourNewPassword":"Password_tourNewPassword__3U3DE","tourRepeatPassword":"Password_tourRepeatPassword__21mgz"};